import React from 'react'
import { Plus } from 'lucide-react'

import { AddCardProps } from 'src/features/AddCard/types'
import { Card, CardHeader } from 'src/components/shadcn/card'

export const AddCard = ({ gotoAddCar }: AddCardProps): JSX.Element => {
  return (
    <Card
      onClick={gotoAddCar}
      className="
        group relative
        h-auto md:h-[94%]
        sm:min-h-[400px]
        max-w-[455px]
        mt-4 flex flex-col
        rounded-xl overflow-hidden cursor-pointer
        transition-all border bg-white text-gray-800 shadow-md
        hover:shadow-lg md:hover:scale-[1.02] dark:bg-gray-900 dark:text-gray-100
        dark:border-gray-700
      "
    >
      <CardHeader className="flex-1 flex items-center justify-center">
        <Plus className="text-gray-700 dark:group-hover:text-white group-hover:text-black w-12 h-12 sm:w-16 sm:h-16" />
      </CardHeader>
    </Card>
  )
}
